//import type { GetParams, PaginatorInfo } from '@/types';
import { HttpClientFront } from './http-client-front';

interface LanguageParam {
  language: string;
}

export function crudFactory(
  endpoint: string
) {
  return {
    all(params: QueryParams) {
      return HttpClientFront.get(endpoint, params);
    },
    paginated(params: QueryParams) {
      return HttpClientFront.get(endpoint, params);
    },
    get({ id }) {
      console.log("pid from get call",id);
      return HttpClientFront.get(`${endpoint}/${id}`);
    },
     getwithoutid() {
      //console.log("pid from get call",id);
      return HttpClientFront.get(`${endpoint}`);
    },
    create(data: InputType) {
      return HttpClientFront.post(endpoint, data);
    },
    update({ id, ...input }) {
      //return HttpClient.put(`${endpoint}/${id}`, input);
    return HttpClientFront.post(`${endpoint}/${id}`, input);
    },
    delete({ id }: { id: string }) {
      return HttpClientFront.delete(`${endpoint}/${id}`);
    },
    deletepost(data: InputType) {
      //console.log("delet curd",endpoint);
      return HttpClientFront.post(endpoint, data);
    },
    createwithmultidata(data) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
      return HttpClientFront.post(endpoint, data,options);
    },
    updatewithmultidata({ id, ...input }) {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
      return HttpClientFront.post(`${endpoint}/${id}`, input,options);
    },
  };
}
